import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeading } from "../components/Reveal";
import { ExperienceCard } from "../components/ExperienceCard";
import { api } from "../lib/api";

export default function Games() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [theme, setTheme] = useState(searchParams.get("theme") || "All");

  useEffect(() => {
    api.list("games").then((d) => { setItems(d); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const themes = ["All", ...new Set(items.map((i) => i.theme).filter(Boolean))];
  const filtered = theme === "All" ? items : items.filter((i) => i.theme === theme);

  return (
    <main className="pt-40 pb-28">
      <Seo title="VR Games & Attractions" path="/games"
        description="VR bungee jumping, paragliding, cricket, skydiving, racing, shooting and multiplayer VR attractions. VR games Hyderabad, VR entertainment India." />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <SectionHeading overline="VR Games & Attractions"
          title={<>Adventure <span className="italic text-zinc-400">Without Limits.</span></>} />
        <Reveal delay={0.15} className="max-w-2xl mt-6">
          <p className="text-zinc-400 font-light leading-relaxed">
            High-energy VR attractions — from bungee jumping and paragliding to cricket, racing and multiplayer arenas. Play at our locations, or install them at yours.
          </p>
        </Reveal>
        {!loading && themes.length > 2 && (
          <div className="flex flex-wrap gap-2 mt-12" data-testid="games-theme-filters">
            {themes.map((t) => (
              <button key={t} onClick={() => setTheme(t)} data-testid={`games-theme-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`px-5 py-2.5 rounded-full text-xs font-mono uppercase tracking-[0.12em] transition-all duration-300 ${theme === t ? "bg-white text-black" : "border border-white/15 text-zinc-400 hover:text-white"}`}>
                {t}
              </button>
            ))}
          </div>
        )}
        {loading ? (
          <p className="mt-20 text-zinc-500 font-mono text-sm" data-testid="games-loading">Loading attractions…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10" data-testid="games-grid">
            {filtered.map((g, i) => (
              <Reveal key={g.id} delay={(i % 3) * 0.06}><ExperienceCard item={g} type="games" index={i} /></Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
